import { SET_APP_SETTINGS } from 'actions'
import createSettingsReducer from '../utils/create-settings-reducer'

export default createSettingsReducer(SET_APP_SETTINGS, {
  shouldShowSourceRestriction: false,
  shouldShowWarehouseRestriction: false
})
